import { render } from "./selectTransportista.vue?vue&type=template&id=18a817bc"
import script from "./selectTransportista.vue?vue&type=script&lang=ts"
export * from "./selectTransportista.vue?vue&type=script&lang=ts"
script.render = render

export default script